import React from 'react';
import './DataManagement.scss';
import List from '../../List/List.jsx';
import ImageList from '../../ImageList/ImageList.jsx';
import Pagination from '../../Pagination/Pagination.jsx';
import { API_NAMES, LANGUAGE_CODES, ROWS_PER_PAGE } from '../../constants.js';

const DataManagement = ({
  apiName,
  countryCode,
  languageCode,
  locationId,
  maxNumberOfRows,
  currentPage,
  count,
  rows,
  locations,
  onApiNameChange,

  onLanguageCodeChange,
  onLocationIdChange,
  onMaxRowsChange,
  onPageChange,
  onSelectClicked,
  onUpdateClicked,
  onShareClicked,
  onDeleteClicked,
}) => {
  const handlePageChange = (page) => {
    onPageChange(page);
  };

  const renderContent = () => {
    switch (apiName) {
      case API_NAMES.RSS:
      case API_NAMES.IMMI:
      case API_NAMES.HOME:
        return (
          <List
            rows={rows}
            isUpdate={true}
            locationId={locationId}
            onSelectClicked={onSelectClicked}
            onUpdateClicked={onUpdateClicked}
            onShareClicked={onShareClicked}
            onDeleteClicked={onDeleteClicked}
            languageCode={languageCode}
            locations={locations}
          />
        );
      case API_NAMES.YOUTUBE:
        return (
          <ImageList
            rows={rows}
            languageCode={languageCode}
            locations={locations}
            locationId={locationId}
            onShareClicked={onShareClicked}
            onDeleteClicked={onDeleteClicked}
          />
        );
      default:
        return null;
    }
  };

  return (
    <section className="data-section">
      <h2>Data Management</h2>
      <div className="condition-container">
        <div>
          <label htmlFor="apiName">API:</label>
          <select id="apiName" value={apiName} onChange={onApiNameChange}>
            <option value={API_NAMES.HOME}>home-api</option>
            <option value={API_NAMES.IMMI}>immi-api</option>
            <option value={API_NAMES.YOUTUBE}>youtube-api</option>
            <option value={API_NAMES.RSS}>rss-api</option>
          </select>
        </div>

        <div>
          <label htmlFor="languageCode">Language:</label>
          <select id="languageCode" value={languageCode} onChange={onLanguageCodeChange}>
            {Object.entries(LANGUAGE_CODES).map(([key, value]) => (
              <option key={key} value={value}>
                {value}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label htmlFor="locationId">Location:</label>
          <select id="locationId" value={locationId} onChange={onLocationIdChange}>
            {locations?.map((location) => (
              <option key={location.id} value={location.id}>
                {languageCode === LANGUAGE_CODES.EN
                  ? location.name_en
                  : location.name_ko}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label htmlFor="maxNumberOfRows">Rows per page:</label>
          <select id="maxNumberOfRows" value={maxNumberOfRows} onChange={onMaxRowsChange}>
            <option value={ROWS_PER_PAGE.FIFTY}>50</option>
            <option value={ROWS_PER_PAGE.HUNDRED}>100</option>
          </select>
        </div>
      </div>
      {renderContent()}
      {count > 0 && (
        <Pagination
          currentPage={currentPage}
          totalCount={count}
          pageSize={maxNumberOfRows}
          onPageChange={handlePageChange}
        />
      )}
    </section>
  );
};

export default DataManagement; 